import { AxiosResponse } from "axios";
import { ChatBotResponse } from "../../types/chat-bot";
import { axiosConfigChatbot } from "../../config/api/configApiChatbot";

export const getCurrentChatBot: () => Promise<
  AxiosResponse<ChatBotResponse>
> = () => {
  return axiosConfigChatbot.get(`console/api/workspaces/app`);
};
